"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
require('../../../ui/js/api-header-injector.js');
window['terminal'] = false;
if (document.URL.indexOf('terminal.html') >= 0 || document.URL.indexOf('terminal-admiral.html') >= 0) {
    window['terminal'] = true;
}
(function initLBGlobalsOnce() {
    var w = window;
    if (!Array.isArray(w.drawnNumbers))
        w.drawnNumbers = [];
    if (typeof w.drawnBalls !== 'number')
        w.drawnBalls = 0;
    if (typeof w.drawnOddBalls !== 'number')
        w.drawnOddBalls = 0;
    if (typeof w.drawnEvenBalls !== 'number')
        w.drawnEvenBalls = 0;
    if (!w.drawnColors || typeof w.drawnColors !== 'object') {
        w.drawnColors = {
            red: 0, blue: 0, green: 0, brown: 0,
            yellow: 0, black: 0, orange: 0, purple: 0
        };
    }
})();
if (document.URL.indexOf('terminal-admiral.html') != -1) {
    if (location.host == 'online.admiralstage.elbet.com' || location.host == 'localhost' ||
        location.host == 'online.elbetdev.com' ||
        location.host == 'online.zb.elbet.com') {
    }
    else {
        location.href = 'https://online.elbet.com/lucky-balls/index.html';
    }
}
require('hacktimer');
require('../../../../node_modules/bootstrap/dist/js/bootstrap.min.js');
require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
require('../../../ui/js/chart.min.js');
require('../../../ui/js/jquery-ui.js');
require('../../../ui/js/jquery.mCustomScrollbar.js');
require('../../../ui/js/charts.js');
window['lang'] = getUrlParam('lang');
window['language'] = window['lang'] === null ? 'en' : window['lang'];
window['help'] = getUrlParam('help');
window['term'] = getUrlParam('term');
require('../js/inactivity-handler.js');
require('../../../ui/js/language.js');
require('../js/common.js');
require('../js/script.js');
if (document.URL.indexOf('terminal-admiral.html') == -1) {
    require('../js/menu.js');
}
require('../js/balls.js');
require('../js/draw.js');
require('../js/game.js');
require('../js/infobar.js');
require('../js/results.js');
require('../js/luckyballs.js');
require('../js/points.js');
require('../js/socket.io.js');
require('../js/charts.js');
require('../../../ui/js/iframe-script.js');
if (window['terminal']) {
    require('../js/terminal.js');
}
if (document.URL.indexOf('terminal-admiral.html') == -1) {
    require('../video/regular_game.mp4');
    require('../video/intro_al.mp4');
    require('../video/intro_ba.mp4');
    require('../video/intro_de.mp4');
    require('../video/intro_en.mp4');
    require('../video/intro_es.mp4');
    require('../video/intro_fr.mp4');
    require('../video/intro_hr.mp4');
    require('../video/intro_it.mp4');
    require('../video/intro_mk.mp4');
    require('../video/intro_ro.mp4');
    require('../video/intro_rs.mp4');
    require('../video/intro_ru.mp4');
    require('../video/bonus_green.mp4');
    require('../video/bonus_yellow.mp4');
}
require.context('../img', true, /\.(gif|png|jpe?g|svg)$/i);
if (window['terminal']) {
    var theme = getUrlParam('theme');
    require('../scss/terminal/style.scss');
    require('../scss/terminal/jquery.numpad.scss');
    if (theme) {
        loadTerminalTheme(String(theme));
    }
}
else {
    console.log('Theme from static config: ', CSS_THEME);
    switch (window.location.hostname) {
        case "online.pinnbet.elbet.com":
            if (getUrlParam('theme') != null) {
                loadForcedOnlineTheme(String(getUrlParam('theme')));
                console.log('Special case [online.pinnbet.elbet.com] [online.elbetdev.com]  theme forced:', getUrlParam('theme'));
            }
            else {
                require('../scss/base.scss');
                console.log('Special case [online.pinnbet.elbet.com] [online.elbetdev.com]  theme base forced');
            }
            break;
        case BABAIJEBU_DOMAIN:
            try {
                require('../scss/' + CSS_THEME + '.scss');
                require('../scss/' + CSS_THEME + '/' + BABAIJEBU_DOMAIN + '.scss');
            }
            catch (e) {
                console.info(e);
            }
            break;
        case "online.elbetdev.com":
            if (getUrlParam('theme') != null) {
                loadForcedOnlineTheme(String(getUrlParam('theme')));
                console.log('Special case [online.elbetdev.com] theme forced:', getUrlParam('theme'));
            }
            else {
                require('../scss/blue.scss');
                console.log('Special case [online.elbetdev.com] theme blue forced');
            }
            break;
        case AMELCO_DOMAIN:
            try {
                require('../scss/' + CSS_THEME + '.scss');
                require('../scss/' + CSS_THEME + '/' + AMELCO_DOMAIN + '.scss');
            }
            catch (e) {
                console.info(e);
            }
            break;
        default:
            if (getUrlParam('theme') != null) {
                loadForcedOnlineTheme(String(getUrlParam('theme')));
                console.log('Special case [FOR ALL] [FORCED] theme :', getUrlParam('theme'));
            }
            else {
                if (location.hostname == 'online.soccer2.elbet.com' || location.hostname == 'online.stage.soccer.elbet.com') {
                    require('../scss/base.scss');
                    console.log('special:green ', CSS_THEME);
                }
                else {
                    require('../scss/' + CSS_THEME + '.scss');
                    console.log('All others load ', CSS_THEME);
                }
            }
    }
}
require('../../../ui/css/jquery.mCustomScrollbar.css');
var balls_1 = require("./balls/balls");
var chosen_balls_1 = require("./balls/chosen-balls");
var ticket_options_1 = require("./tickets/ticket-options");
var ticket_played_1 = require("./tickets/ticket-played");
var tickets_holder_1 = require("./tickets/tickets-holder");
var statistics_1 = require("./statistics/statistics");
var api_1 = require("./api/api");
var user_1 = require("./user/user");
var auth_1 = require("./auth/auth");
var login_modal_helper_1 = require("./helpers/login-modal-helper");
var credit_1 = require("./credit/credit");
var cookie_helper_1 = require("./helpers/cookie-helper");
var navbar_display_1 = require("./navbar/navbar-display");
var input_helper_1 = require("./helpers/input-helper");
var format_money_1 = require("./helpers/format-money");
var version_switcher_1 = require("./version-switcher/version-switcher");
var v5_socket_1 = require("../js/v5-socket");
window['API_URL'] = API_URL;
window['$'] = require('jquery');
window['jquery'] = window['$'];
window['jQuery'] = window['$'];
var SPECIAL_API_URL = 'https://api.elbet.us/index.php';
var SPECIAL_API_URL_DOMAINS = ['online.try.everymatrix.elbet.us'];
if (SPECIAL_API_URL_DOMAINS.indexOf(window.location.hostname) >= 0) {
    window['API_URL'] = SPECIAL_API_URL;
    console.log('Special API URL for domain ' + window.location.hostname + ' : ' + SPECIAL_API_URL);
}
$(document).ready(function () {
    require('bootstrap-css');
    if (/terminal\.html|terminal-admiral\.html/.test(window.location.href)) {
        var w = window;
        var cookieTok = cookie_helper_1.default.get('token');
        if (cookieTok !== '' && cookieTok != null && cookieTok !== undefined) {
            w['token'] = cookieTok;
        }
        else {
            w['token'] = getUrlParam('token');
        }
    }
    if (getUrlParam('interval') == null) {
        window.drawInterval = 3;
    }
    else {
        window.drawInterval = getUrlParam('interval');
        window.drawInterval = parseFloat(window.drawInterval);
        if (window.drawInterval > 5)
            window.drawInterval = 5;
    }
    var api = new api_1.default(window['API_URL'] + '/luckyballs');
    api.send('/game-config/get', {}, function (response) {
        window['menu'] = (response['Online_Menu'] !== undefined && response['Online_Menu'] !== '' && response['Online_Menu'] != null) ? response['Online_Menu'] : false;
        window['useJackpot'] = (response['useJackpot'] !== undefined && response['useJackpot'] !== '' && response['useJackpot'] != null) ? true : false;
        window['LogoURL'] = (response['LogoURL'] !== undefined && response['LogoURL'] !== '' && response['LogoURL'] != null) ? response['LogoURL'] : 'header_elbet.png';
        var bingoGameName = (response['BingoGameName'] !== undefined && response['BingoGameName'] !== '' && response['BingoGameName'] != null) ? response['BingoGameName'] :
            (response['Bingo_GameName'] !== undefined && response['Bingo_GameName'] !== '' && response['Bingo_GameName'] != null) ? response['Bingo_GameName'] :
                (response['Bingo49_GameName'] !== undefined && response['Bingo49_GameName'] !== '' && response['Bingo49_GameName'] != null) ? response['Bingo49_GameName'] : null;
        if (bingoGameName) {
            window['BingoGameName'] = bingoGameName;
        }
        window['purchaseConfirmation'] = (response['purchaseConfirmation'] !== undefined && response['purchaseConfirmation'] !== '' && response['purchaseConfirmation'] != null) ? response['purchaseConfirmation'] : 0;
        window['showLogin'] = (response['showLogin'] !== undefined && response['showLogin'] !== '' && response['showLogin'] != null) ? response['showLogin'] : 0;
        window['V4'] = (response['DisplayType'] !== undefined && response['DisplayType'] !== '' && response['DisplayType'] != null) ? response['DisplayType'] : 3;
        if ((((window.V4 !== 4 && window.V4 !== 5) ||
            /terminal/.test(window.location.href)) &&
            location.hostname != 'online.soccer2.elbet.com' &&
            location.hostname != 'online.stage.soccer.elbet.com' &&
            location.hostname != 'online.weldmag.elbet.com')) {
            window['preload']();
            console.log("V3");
        }
        if (!(/terminal/.test(window.location.href))) {
            var versionSwitcher = new version_switcher_1.default();
            versionSwitcher.specificDomainChanges();
            if (window.V4 == 4 || window.V4 == 5 || location.hostname == 'online.soccer2.elbet.com' ||
                location.hostname == 'online.stage.soccer.elbet.com' ||
                location.host == 'online.elbetdev.com' ||
                location.host == 'online.zb.elbet.com' ||
                location.host == 'online.weldmag.elbet.com') {
                if (location.host == 'online.zb.elbet.com') {
                    window['v5socket'] = new v5_socket_1.default();
                    versionSwitcher.switchForceV5('admiral');
                }
                else if (location.host == 'online.elbetdev.com') {
                    versionSwitcher.switch(window['V4']);
                }
                else if (location.host == 'online.maxbet.mne.elbet.com') {
                    window['v5socket'] = new v5_socket_1.default();
                    versionSwitcher.switchForceV5('maxbet_mne');
                }
                else if (location.host == 'online.dev.elbetdev.com') {
                    window['v5socket'] = new v5_socket_1.default();
                    versionSwitcher.switchForceV5('dev');
                }
                else if (location.host == 'online.jokker.elbetdev.com') {
                    window['v5socket'] = new v5_socket_1.default();
                    versionSwitcher.switchForceV5('jokker');
                }
                else if (location.host == 'online.weldmag.elbet.com') {
                    window['v5socket'] = new v5_socket_1.default();
                    versionSwitcher.switchForceV5('weldmag');
                }
                else {
                    versionSwitcher.switch(window['V4']);
                }
            }
        }
        window['currency'] = response.Currency;
        $('#currency').text(window['currency']);
        window['customLoggedIn'] = false;
        window['customToken'] = '';
        if (window['showLogin'] !== 1 || cookie_helper_1.default.get('token') === '') {
            window['token'] = getUrlParam('token');
        }
        else {
            window['token'] = cookie_helper_1.default.get('token');
        }
        if (window['menu'] && !/electron=true/.test(window.location.href)) {
            document.body.style.opacity = '1';
            $('#nav-icon1').show();
            $('.terminal-left').show();
            if (document.URL.indexOf('terminal-admiral.html') == -1) {
                window['renderMenu']();
            }
        }
        else {
            document.body.style.opacity = '1';
            var contentTab = document.querySelector('.terminal-content-tabs');
            var contentTabs = document.querySelector('.terminal-tabs');
            if (contentTab) {
                contentTab.classList.add('terminal-full-width');
            }
            if (contentTabs) {
                contentTabs.classList.add('terminal-full-width');
            }
        }
        switch (response['ManualCombMinCombBet']) {
            case -1:
                window['allColorsMinBet'] = response['Bingo_MinBet'] * 8;
                break;
            case 0:
                window['allColorsMinBet'] = response['Bingo_MinBet'] * 8;
                break;
            case 1:
                window['allColorsMinBet'] = response['Bingo_MinBetCombination'] * 8;
                break;
        }
        if (window['showLogin'] === 1) {
            $('.game-nav-bar').css('display', 'flex');
        }
        else {
            $('.game-nav-bar').css('display', 'none');
        }
        showBettingValues(response);
    }, function () { });
    var balls = new balls_1.default();
    var chosenBalls = new chosen_balls_1.default(balls);
    var ticketOptions = new ticket_options_1.default(chosenBalls, api);
    var ticketsHolder = new tickets_holder_1.default();
    var user = new user_1.default();
    var auth = new auth_1.default(api);
    var credit = new credit_1.default(api);
    var navbar = new navbar_display_1.default();
    ticketOptions.attachListeners();
    window.addEventListener('get_tickets_no_stats', function () {
        getTickets(api, ticketsHolder);
    });
    window['loggedOut'] = new Event('loggedOut');
    window.addEventListener('get_tickets', function () {
        getStatistics(api);
        getTickets(api, ticketsHolder);
    });
    window.addEventListener('update_tickets', function () {
        if (window['ticketsTaken'] !== true) {
            getStatistics(api);
            getTickets(api, ticketsHolder);
        }
        ticketsHolder.setAllowWinnerPromote(true);
        ticketsHolder.updateTickets();
    });
    window.addEventListener('logout', function () {
        auth.logout();
    });
    window.addEventListener('getTicket', function (e) {
        getTicket(api, e.detail.ticketId, e.detail);
    });
    window.addEventListener('get_credit', function () {
        credit.getCredit(user);
    });
    window.addEventListener('payout', function () {
        credit.requestPayout(user);
    });
    loginManagement(auth, user, navbar, credit);
});
$('.payout-pin-button').click(function () {
    var payoutEvent = new CustomEvent('payout');
    window.dispatchEvent(payoutEvent);
});
function loadTerminalTheme(theme) {
    switch (theme) {
        case 'maxbet':
            require('../scss/terminal/themes/maxbet.scss');
            console.log('[TERMINAL] Učitana tema: ' + theme);
            break;
        default:
            console.warn('[TERMINAL] Tema "' + theme + '" nije pronađena, koristi se podrazumevana');
            break;
    }
}
function loadForcedOnlineTheme(theme) {
    if (theme === 'maxbet') {
        theme = 'blue';
    }
    switch (theme) {
        case 'base':
            require('../scss/base.scss');
            break;
        case 'blue':
            require('../scss/blue.scss');
            break;
        case 'orange':
            require('../scss/orange.scss');
            break;
        case 'pink':
            require('../scss/pink.scss');
            break;
        default:
            console.warn('Unknown theme "' + theme + '", using default');
            require('../scss/blue.scss');
            break;
    }
}
function getUrlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    else {
        return decodeURI(results[1]) || 0;
    }
}
function showBettingValues(response) {
    window['Bingo_MinBet'] = response['Bingo_MinBet'];
    window['Bingo_MinBetCombination'] = response['Bingo_MinBetCombination'];
    $('#betting-values').show();
    $('#min-bet').text(response['Bingo_MinBet']).attr('data-value', response['Bingo_MinBet']);
    $('#max-bet').text(response['Bingo_MaxBet']).attr('data-value', response['Bingo_MaxBet']);
    $('#bet-100').text(response['CustomAmount1']).attr('data-value', response['CustomAmount1']);
    $('#bet-200').text(response['CustomAmount2']).attr('data-value', response['CustomAmount2']);
    $('#bet-400').text(response['CustomAmount3']).attr('data-value', response['CustomAmount3']);
    $('[data-predefined="1"]').text(response['CustomAmount1']).attr('data-value', response['CustomAmount1']);
    $('[data-predefined="2"]').text(response['CustomAmount2']).attr('data-value', response['CustomAmount2']);
    $('[data-predefined="3"]').text(response['CustomAmount3']).attr('data-value', response['CustomAmount3']);
    $('[data-predefined="min"]').attr('data-value', response['Bingo_MinBet']);
    $('[data-predefined="max"]').attr('data-value', response['Bingo_MaxBet']);
    $('#betting-btn').val(parseFloat(response['Bingo_MinBet']).toFixed(2))
        .attr('min', response['Bingo_MinBet'])
        .attr('max', response['Bingo_MaxBet'])
        .attr('step', response['Bingo_MinBet']);
}
function getStatistics(api) {
    api.send('/statistics/get', { 'noOfGames': 30 }, function (response) {
        var stats = new statistics_1.default(response['Data']['BingoStats'][0]);
        $('#betting-advanced').show();
        stats.show();
    }, function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
    });
}
function getTicketRoundDisplayId(row) {
    if (row['ItemTodayGameID'] != null && row['ItemTodayGameID'] !== '') {
        return String(row['ItemTodayGameID']);
    }
    if (row['tempID_Today'] != null && row['tempID_Today'] !== '') {
        return String(row['tempID_Today']);
    }
    return '';
}
function getTicketItemGameId(row) {
    var e_1, _a;
    if (!row) {
        return '';
    }
    var keys = ['ItemGameID', 'ItemGameId', 'ID_Game', 'GameID', 'IDGame'];
    try {
        for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var key = keys_1_1.value;
            if (row[key] != null && row[key] !== '') {
                return String(row[key]);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return '';
}
function getTicketDisplayAmount(row) {
    var raw = '';
    if (row.ItemAmount != null && row.ItemAmount !== '' && Number(row.ItemAmount) > 0) {
        raw = String(row.ItemAmount);
    }
    else if (row.RoundAmount != null && row.RoundAmount !== '' && Number(row.RoundAmount) > 0) {
        raw = String(row.RoundAmount);
    }
    else {
        var roundsTotal = Number(row.RoundsTotal);
        var ticketAmount = Number(row.TicketAmount);
        if (roundsTotal > 1 && ticketAmount > 0) {
            raw = String(ticketAmount / roundsTotal);
        }
        else if (row.TicketAmount != null) {
            raw = String(row.TicketAmount);
        }
    }
    return raw !== '' ? format_money_1.formatBetAmount(raw) : '';
}
function getTicketGroupKey(row) {
    var ticketID = String(row['TicketID']);
    var itemGameId = getTicketItemGameId(row);
    if (itemGameId) {
        return ticketID + '-itemgame-' + itemGameId;
    }
    var roundId = getTicketRoundDisplayId(row);
    if (roundId) {
        return ticketID + '-round-' + roundId;
    }
    return ticketID + '-open';
}
function getActiveTicketsFromResponse(response) {
    if (!response || !response.Data || !response.Data.BingoTicket) {
        return [];
    }
    var list = response.Data.BingoTicket;
    return Array.isArray(list) ? list : Object.values(list);
}
function getTickets(api, ticketsHolder) {
    ticketsHolder.clearTickets();
    window['ticketsTaken'] = true;
    api.send('/ticket/get', { 'SessionID': window['token'] }, function (response) {
        if ('OpenTickets' in response) {
            if (Number(response['OpenTickets']) > 0) {
                document.querySelector('.open-tickets-hidden') ?
                    document.querySelector('.open-tickets-hidden').innerHTML = "(+" + response['OpenTickets'] + ")" : '';
                document.querySelector('.open-tickets') ?
                    document.querySelector('.open-tickets').innerHTML = "(+" + response['OpenTickets'] + ")" : '';
            }
            else {
                document.querySelector('.open-tickets-hidden') ?
                    document.querySelector('.open-tickets-hidden').innerHTML = '' : '';
                document.querySelector('.open-tickets') ?
                    document.querySelector('.open-tickets').innerHTML = '' : '';
            }
        }
        var ticketRows = getActiveTicketsFromResponse(response);
        var ticketGroups = [];
        var groupIndexByKey = {};
        for (var rowIndex = 0; rowIndex < ticketRows.length; rowIndex++) {
            var row = ticketRows[rowIndex];
            var groupKey = getTicketGroupKey(row);
            var groupPos = groupIndexByKey[groupKey];
            if (groupPos === undefined) {
                groupPos = ticketGroups.length;
                groupIndexByKey[groupKey] = groupPos;
                ticketGroups.push({ key: groupKey, rows: [] });
            }
            var roundsTotal = (row['RoundsTotal'] !== undefined && row['RoundsTotal'] !== '' && row['RoundsTotal'] != null)
                ? row['RoundsTotal']
                : '';
            var currentRound = (row['CurrentRound'] !== undefined && row['CurrentRound'] !== '' && row['CurrentRound'] != null)
                ? row['CurrentRound']
                : '';
            ticketGroups[groupPos].rows.push({
                'TicketID': row['TicketID'],
                'DisplayId': groupKey,
                'TicketAmount': getTicketDisplayAmount(row),
                'OddType': row['OddType'],
                'Odd': row['Odd'],
                'Numbers': row['Numbers'],
                'JPCode': row['JPCode'],
                'RoundID': getTicketRoundDisplayId(row),
                'ItemCount': row['ItemCount'],
                'RoundsTotal': roundsTotal,
                'CurrentRound': currentRound,
                'TicketStatus': row['TicketStatus'],
                'ItemStatus': row['ItemStatus'],
                'ItemAmount': row['ItemAmount'],
                'ItemGameID': getTicketItemGameId(row),
                'ItemEvMinWin': row['ItemEvMinWin'],
                'ItemEvMaxWin': row['ItemEvMaxWin'],
                'ItemEvWin': row['ItemEvWin'],
                'ItemWinMoney': row['ItemWinMoney']
            });
        }
        ticketsHolder.clearTickets();
        var ticket;
        for (var g = 0; g < ticketGroups.length; g++) {
            var rows = ticketGroups[g].rows;
            if (typeof window['jackpotObj'] === 'object' && Object.keys(window['jackpotObj']).length) {
                if (rows[0]['JPCode'] && String(rows[0]['JPCode']).trim() !== "" && window['jackpotObj'].jackpotCode.trim() !== "") {
                    if (String(rows[0]['JPCode']) === String(window['jackpotObj'].jackpotCode)) {
                        var showJackpotEvent_1 = new CustomEvent('showJackpotEvent', { detail: window['jackpotObj'] });
                        window.dispatchEvent(showJackpotEvent_1);
                        ticket = new ticket_played_1.default(rows, ticketsHolder, true);
                    }
                    else {
                        ticket = new ticket_played_1.default(rows, ticketsHolder);
                        if (document.querySelector('.jackpot-informer'))
                            document.querySelector('.jackpot-informer').style.display = 'none';
                    }
                }
                else {
                    ticket = new ticket_played_1.default(rows, ticketsHolder);
                    if (document.querySelector('.jackpot-informer'))
                        document.querySelector('.jackpot-informer').style.display = 'none';
                }
            }
            else {
                ticket = new ticket_played_1.default(rows, ticketsHolder);
                if (document.querySelector('.jackpot-informer'))
                    document.querySelector('.jackpot-informer').style.display = 'none';
            }
            ticketsHolder.addTicket(ticket);
        }
        if (!ticketGroups.length) {
            if (document.querySelector('.jackpot-informer')) {
                document.querySelector('.jackpot-informer').style.display = 'none';
            }
        }
        ticketsHolder.showTickets();
        ticketsHolder.updateTickets();
    }, function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
    });
}
function getTicket(api, id, ticketData) {
    api.send('/ticket/get/id', { 'ticketId': id }, function (response) {
        if (response.TicketData) {
            if (response.TicketData.TicketData.length > 0) {
                var numbers = response.TicketData.TicketData[0].
                    Numbers.replace(/\|/g, ',').substring(1).slice(0, -1).
                    split(',').map(function (numbero) {
                    return parseInt(numbero, 10);
                });
                numbers.sort(function (a, b) { return a - b; });
                var respObj = {
                    selectedNumbers: numbers,
                    winMoney: response.TicketData.TicketData[0].WinMoney,
                    bonusMoney: response.TicketData.TicketData[0].BonusMoney,
                    jPWinMoney: response.TicketData.TicketData[0].JPWinMoney,
                    happyGameMoney: response.TicketData.TicketData[0].HappyGameMoney,
                    payout: response.TicketData.TicketData[0].Payout,
                    ticketAmount: response.TicketData.TicketData[0].TicketAmount,
                    ticketStatus: response.TicketData.TicketData[0].TicketStatus
                };
                Object.assign(ticketData, respObj);
                var shareTicketEvent = new CustomEvent('shareTicketEvent', {
                    bubbles: true,
                    detail: ticketData
                });
                window.dispatchEvent(shareTicketEvent);
                return response;
            }
        }
    }, function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
    });
}
function loginManagement(auth, user, navbar, credit) {
    if (user.isLogggedIn()) {
        window['token'] = cookie_helper_1.default.get('token');
        var response = {
            Data: {
                AuthUserResponse: [
                    {
                        Credit: credit.getCredit(user),
                        Currency: cookie_helper_1.default.get('currency')
                    }
                ]
            }
        };
        navbar.showLogedIn(user, response);
    }
    else {
        navbar.showLogedOut();
    }
    $('.logout-button').click(function () {
        var logoutEvent = new CustomEvent('logout');
        window.dispatchEvent(logoutEvent);
    });
    $('.login-button').click(function () {
        $('.login-modal').modal('show');
    });
    $('.login-user-button').click(function () {
        auth.login(login_modal_helper_1.default.bind(user));
    });
    $('.user-username').on('keydown', function (e) {
        if (e.which === 13) {
            auth.login(login_modal_helper_1.default.bind(user));
        }
    });
    $('.user-password').on('keydown', function (e) {
        if (e.which === 13) {
            auth.login(login_modal_helper_1.default.bind(user));
        }
    });
    $('.login-modal').on('hidden.bs.modal', function () {
        login_modal_helper_1.default.clearloginInputs();
    });
    $('.login-modal').on('hidden.bs.modal', function () {
        login_modal_helper_1.default.clearloginInputs();
    });
    var ticketPinInput = document.getElementById('betting-btn');
    input_helper_1.default.setInputFilter(ticketPinInput, function (value) {
        return /^\d*\.?\d*$/.test(value);
    });
    if (ticketPinInput) {
        ticketPinInput.oninput = function () {
            input_helper_1.default.setMaxInputLength(ticketPinInput, 8);
            input_helper_1.default.setInputFilter(ticketPinInput, function (value) {
                return /^\d*\.?\d*$/.test(value);
            });
        };
    }
    var roundsInput = document.getElementById('subscription-btn');
    input_helper_1.default.setInputFilter(roundsInput, function (value) {
        return /^\d{1,2}[\W_]?/.test(value);
    });
    if (roundsInput) {
        roundsInput.oninput = function () {
            input_helper_1.default.setMaxInputLength(roundsInput, 2);
            input_helper_1.default.setInputFilter(roundsInput, function (value) {
                return /^\d*\.?\d*$/.test(value);
            });
        };
    }
}
window['appVersion'] = "V0.1.5.8";
console.log('Release: ' + window['appVersion']);



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/main.ts
// module id = 864
// module chunks = 0